import { Deserializable } from '../deserializable.model';

export class BuyFunctionality implements Deserializable {
    name: string;
    venueName: string;
    ShortDescriptive1: string;
    dates: string;
    eventListPricesName: string;
    type: string;
    basePrice: number;
    priceToPick: any;

    deserialize(input: any): this {
        Object.assign(this, input);
        return this;
    }
}
